const CustomDot = ({ onClick, active }) => (
    <button
      onClick={onClick}
      className={`mx-1 h-1 rounded-full transition-all duration-300 ${
        active
          ? "w-10 bg-white"
          : "w-4 bg-white/40 hover:bg-white/70"
      }`}
    />
  );

export default CustomDot;